var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.88002 0.0400391C4.70862 0.0400391 0.52002 4.33458 0.52002 9.63679C0.52002 13.8833 3.19932 17.4701 6.91992 18.7417C7.38792 18.8257 7.56342 18.5378 7.56342 18.2859C7.56342 18.0579 7.55172 17.3022 7.55172 16.4985C5.20002 16.9423 4.59162 15.9107 4.40442 15.3708C4.29912 15.0949 3.84282 14.2432 3.44502 14.0153C3.11742 13.8354 2.64942 13.3915 3.43332 13.3795C4.17042 13.3675 4.69692 14.0753 4.87242 14.3632C5.71482 15.8147 7.06032 15.4068 7.59852 15.1549C7.68042 14.5311 7.92612 14.1113 8.19522 13.8714C6.11262 13.6314 3.93642 12.8037 3.93642 9.13296C3.93642 8.08931 4.29912 7.22561 4.89582 6.55383C4.80222 6.31391 4.47462 5.33025 4.98942 4.01069C4.98942 4.01069 5.77332 3.75878 7.56342 4.99436C8.31222 4.77843 9.10782 4.67047 9.90342 4.67047C10.699 4.67047 11.4946 4.77843 12.2434 4.99436C14.0335 3.74678 14.8174 4.01069 14.8174 4.01069C15.3322 5.33025 15.0046 6.31391 14.911 6.55383C15.5077 7.22561 15.8704 8.07732 15.8704 9.13296C15.8704 12.8157 13.6825 13.6314 11.5999 13.8714C11.9392 14.1713 12.2317 14.7471 12.2317 15.6468C12.2317 16.9303 12.22 17.962 12.22 18.2859C12.22 18.5378 12.3955 18.8377 12.8635 18.7417C16.5607 17.4701 19.24 13.8714 19.24 9.63679C19.24 4.33458 15.0514 0.0400391 9.88002 0.0400391Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.3f273da3f421ece15a963978d991f33c.svg";
export { ForwardRef as ReactComponent };